import { Fragmento } from "./fragmento.model";
import { Sinonimo } from "./sinonimo.model";

export class Recurso {
	idRecurso: number;
	url = '';
	identificador = '';
	idAto: number;
    sinonimos: Sinonimo[] = [];
    fragmentos: Fragmento[] = [];

	incluirSinonimo(sinonimo: string) {
		this.sinonimos.push(new Sinonimo(sinonimo));
	}

	incluirFragmentoIntegra() {
		this.fragmentos.push(new Fragmento('', 'íntegra', 0));
	}
}
